const DayIndexSinceFirstJanuary = () => {
    const now = new Date();

    const startOfYear = new Date(now.getFullYear(), 0, 1);

    const diff =
        Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) -
        Date.UTC(
            startOfYear.getFullYear(),
            startOfYear.getMonth(),
            startOfYear.getDate()
        );

    return Math.floor(diff / 86400000);
};

export default DayIndexSinceFirstJanuary;